export default __webpack_public_path__ + "imgs/box_1.png";